import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { grey, red } from '@material-ui/core/colors';
//import { motion } from 'framer-motion';
//models
import Message from '../models/Message';
import { TextLinkResponse } from '../models/Conversation';
import { errorMessage } from '../models/Constants';

//import Grow from '@material-ui/core/Grow';

import Zoom from '@material-ui/core/Zoom';

//To make changes of Block card and PMSBY kind of msg response consult this file
const useStyles = makeStyles((theme) => ({
    adi: {
      padding: theme.spacing(2),
      maxWidth: '300px',
      color: theme.palette.getContrastText(grey[200]),
      backgroundColor: grey[200],
      borderRadius:20,
      borderTopRightRadius: 10,
      borderBottomLeftRadius: 0,
    },
    error: {
      padding: theme.spacing(2),
      maxWidth: '300px',
      color: theme.palette.getContrastText(red[500]),
      backgroundColor: red[500],
      borderRadius:20,
      borderTopRightRadius: 5,
      borderBottomLeftRadius: 0,
    },
    a: {
      textDecoration:"underline"
    }
  }));

const MessageTextLink = (props:any) => {
    const classes = useStyles();
    const message:Message = props.message;
    if (!message.messageData) {
      // message.messageData = errorMessage[Math.floor(Math.random() * errorMessage.length)];
      message.messageData = errorMessage[crypto.getRandomValues(new Uint8Array(1))[0]];
      return (
        <Zoom in={true}>
          <Paper elevation={0} className={classes.adi}>
              {message.messageData}
          </Paper>
        </Zoom>
      );
    }
    else {
      const textLink:TextLinkResponse = message.messageData as TextLinkResponse;
      return (
        <Paper elevation={0} className={classes.adi}>
            <div dangerouslySetInnerHTML={{__html: textLink.text}}/>
        </Paper>
      );
    }
   
};

export default MessageTextLink;